module.exports = __webpack_public_path__ + "static/dashboard_intro4_en@2x-d7315b3f5c6fd9dc52a8677e35b6899f.png";